import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';
import {
  CreateAccountModel,
  ChangePasswordModel,
  UpdateUserRequest,
  User,
  AccountsResponse,
  Role,
  SimpleUser,
  UserGroup,
  UserGroupAssignment,
} from '@intellio/shared/models';
import { mergeMap, switchMap, tap } from 'rxjs/operators';
import { BehaviorSubject, of } from 'rxjs';
import { RoleService } from './role.service';
import { Company } from "@intellio/shared/models";

@Injectable({
    providedIn: 'root',
})

export class CompanyService extends BaseService {

    constructor(
        client: HttpClient,
        configService: AppConfigService,
        authService: AuthService,
        private roleService: RoleService
      ) {
        super(client, configService, authService);
      }

      getAllCompanies(){
        const url = '/api/companies';
        return this.get<Company>(url);
      }

      getCompany(id: number, skip: number = 0, take?: number){
        const url = `/api/companies/${id}`;
        const params: { skip: number; take?: number } = { skip };

        if (take !== null && take !== undefined) {
          params.take = take;
        }

        return this.get<Company>(url, { params });
      }

      getBusinessIdentifierByUserId(userId: string){
        const url = `/api/companies/businessIdentifier/${userId}`;
        return this.get<string>(url);
      }

      getCompanyByUserId(userId: string){
        const url = `/api/companies/members/${userId}`;
        return this.get<Company>(url);
      }

      createCompany(organizationName: string, companyName: string, domain: string, businessIdentifier: string) {
        const url = '/api/companies';
        return this.post(url, {organizationName, companyName, domain, businessIdentifier});
      }

      updateCompany(id: number, organizationName: string, companyName: string, domain: string, businessIdentifier: string) {
        const url = `/api/companies/${id}`;
        return this.put(url, {organizationName, companyName, domain, businessIdentifier});
      }

      deleteCompany(id: number){
        const url = `/api/companies/${id}`;
        return this.delete(url);
      }

      addMemberToCompanyByDomain(userId: string, domain: string) {
        const url = `/api/companies/members`;
        return this.post(url, { userId, domain });
      }

      addMemberToCompanyByCompanyId(userId: string, companyId: number) {
        const url = `/api/companies/members/byCompanyId`;
        return this.post(url, { userId, companyId });
      }

      removeMemberFromCompany(id: number, userId: string) {
        const url = `/api/companies/${id}/members/${userId}`;
        return this.delete(url);
      }
}